/**
 *
 * ThemeProvider
 *
 */

import React, { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { ptBR } from '@material-ui/core/locale';
import { createTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { getContextTheme } from 'themes';

// Components
import { ThemeBaseProvider } from 'components';

const CONTEXT_ROUTES = [
  { key: 'sellers', path: '/sellers/:sellerSlug' },
  { key: 'institutions', path: '/institutions/:institutionSlug' },
];

export function ThemeProvider(props) {
  const { children } = props;
  const { pathname } = useLocation();

  const contextKey = useMemo(
    () => CONTEXT_ROUTES.find(route => matchPath(pathname, { path: route.path }))?.key || null,
    [pathname],
  );

  const settings = useMemo(() => createTheme(getContextTheme(contextKey), ptBR), [contextKey]);

  return useMemo(
    () => <ThemeBaseProvider theme={settings}>{children}</ThemeBaseProvider>,
    [settings, children],
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.any,
};

export default ThemeProvider;
